export const USER_LOGGED_IN = "USER_LOGGED_IN";
export const USER_LOGGED_OUT = "USER_LOGGED_OUT";
export const USER_AUTHORIZATION_SUCCESS = "USER_AUTHORIZATION_SUCCESS";
export const LOAD_USER_INFO = "LOAD_USER_INFO";
export const USER_LOG_OUT = "USER_LOG_OUT";
export const LOAD_TEMP_INFO = "LOAD_TEMP_INFO";
